import(/* webpackMode: "eager" */ "C:\\MC\\personal coding\\icongeneratorai\\src\\components\\icon\\GenerateIconForm.tsx")